import { createAsyncThunk } from '@reduxjs/toolkit';

import type { RootState } from '../../store-kit';
import { selectDataSummary } from '../data-summary/data-summary-slice';
import * as fromSlice from './graph-styling-slice';

export const resetStyling = createAsyncThunk<void, void, { state: RootState }>(
  'graph-styling/resetStyling',
  (_, { getState, dispatch }) => {
    const { data } = selectDataSummary(getState());
    dispatch(
      fromSlice.stylingResetToDefault({
        existingLabels: data?.labels ?? [],
        existingRelTypes: data?.relationshipTypes ?? [],
      }),
    );
  },
);
